import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, Spinner, Text, Alert, AlertIcon } from '@chakra-ui/react';

const ConductorPerfil = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('ConductorPerfil - user:', user);
    console.log('ConductorPerfil - isAuthenticated:', isAuthenticated);
    
    if (!isAuthenticated) {
      setError('No estás autenticado');
      return;
    }

    if (!user) {
      setError('No se pudo obtener la información del usuario');
      return;
    }

    // El user puede tener el id directamente o puede que necesitemos obtenerlo del backend
    const conductorId = user.id || user.conductor_id || user.user_id;
    
    if (conductorId) {
      console.log('Redirigiendo a:', `/admin/editar-conductor/${conductorId}?mode=read`);
      navigate(`/admin/editar-conductor/${conductorId}?mode=read`, { replace: true });
    } else {
      setError('No se encontró el ID del conductor en el usuario autenticado');
    }
  }, [isAuthenticated, user, navigate]);

  if (error) {
    return (
      <Box p={4}>
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={4} display="flex" justifyContent="center" alignItems="center" minH="200px">
      <Spinner size="xl" />
      <Text ml={4}>Cargando perfil...</Text>
    </Box>
  );
};

export default ConductorPerfil;
